import {DateField, Panes} from '@management-ui/core';
import React from 'react';

const Fields = ({entity = {}, prefix = ''}) => {
  return (
    <Panes
      entity={entity}
      prefix={prefix}
      panes={[
        {
          title: '',
          fields: [
            <DateField
              name="date"
              prefix={prefix}
              label="Date"
            />,
          ]
        }
      ]}
    />
  );
};

export default Fields;
